// extracted by mini-css-extract-plugin
export var chevron = "_jc-2";
export var dropdownItems = "_jc-0";
export var item = "_jc-1";